    <ng-container *ngIf="!dataHealthLoading; else dhLoadingState">
      <div class="dh-kpi-grid">
        <article class="kpi-card">
          <span class="kpi-label">Health % (Weighted)</span>
          <div class="kpi-value">{{ dataHealthWeightedHealthPct | number:'1.1-1' }}%</div>
          <div class="kpi-delta">Overall Calculated Health %</div>
        </article>
        <article class="kpi-card">
          <span class="kpi-label">Quality %</span>
          <div class="kpi-value">{{ dataHealthWeightedQualityPct | number:'1.1-1' }}%</div>
          <div class="kpi-delta">Overall Quality %</div>
        </article>
        <article class="kpi-card">
          <span class="kpi-label">Health Fault Count</span>
          <div class="kpi-value dh-kpi-value-critical">{{ dataHealthTotalHealthFaultCount | number }}</div>
          <div class="kpi-delta">Total Across All Shops</div>
        </article>
        <article class="kpi-card">
          <span class="kpi-label">Quality Fault Count</span>
          <div class="kpi-value dh-kpi-value-warning">{{ dataHealthTotalQualityFaultCount | number }}</div>
          <div class="kpi-delta">Total Across All Shops</div>
        </article>
        <article class="kpi-card">
          <span class="kpi-label">Shops To Verify</span>
          <div class="kpi-value">{{ dataHealthShopsToVerifyCount }}</div>
          <div class="kpi-delta">100% Health or 0 Health Count</div>
        </article>
      </div>

      <div class="dh-summary-grid">
        <article class="panel dh-panel">
          <h3 class="section-title">Health % Distribution (by Shop)</h3>
          <div class="dh-distribution-wrap">
            <div class="dh-donut" [style.background]="dataHealthDonutSegments">
              <div class="dh-donut-center">{{ dataHealthTotalShops }}</div>
              <span>Shops</span>
            </div>
            <div class="dh-distribution-legend">
              <div class="dh-dist-item" *ngFor="let item of dataHealthDistributionItems; trackBy: trackByIndex">
                <i class="dh-dist-dot" [style.background]="item.color"></i>
                <span>{{ item.label }}</span>
                <strong>{{ item.count }} ({{ percentageOfTotalShops(item.count) | number:'1.1-1' }}%)</strong>
              </div>
            </div>
          </div>
          <p class="dh-note">100% Health is treated as Verify and requires review.</p>
        </article>

        <article class="panel dh-panel">
          <h3 class="section-title">Health % by NAMC</h3>
          <div class="dh-bar-list">
            <div class="dh-bar-row" *ngFor="let row of dataHealthByNamcRows; trackBy: trackByDataHealthNamc">
              <span>{{ row.namc }}</span>
              <div class="dh-bar-track">
                <div class="dh-bar dh-bar--health"
                  [style.width.%]="maxHealthPctAcrossNamc > 0 ? (row.healthPct / maxHealthPctAcrossNamc) * 100 : 0"></div>
              </div>
              <strong>{{ row.healthPct | number:'1.1-1' }}%</strong>
            </div>
          </div>
        </article>

        <article class="panel dh-panel">
          <h3 class="section-title">Quality % by NAMC</h3>
          <div class="dh-bar-list">
            <div class="dh-bar-row" *ngFor="let row of qualityByNamcRows; trackBy: trackByDataHealthNamc">
              <span>{{ row.namc }}</span>
              <div class="dh-bar-track">
                <div class="dh-bar dh-bar--quality"
                  [style.width.%]="maxQualityPctAcrossNamc > 0 ? (row.qualityPct / maxQualityPctAcrossNamc) * 100 : 0"></div>
              </div>
              <strong>{{ row.qualityPct | number:'1.1-1' }}%</strong>
            </div>
          </div>
        </article>

        <article class="panel dh-panel">
          <h3 class="section-title">Ring Buffer Health (Across All Shops)</h3>
          <table class="dh-ring-table">
            <thead>
              <tr>
                <th>Ring Buffer</th>
                <th class="numeric">Count</th>
                <th>Health</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rb of dataHealthRingBufferRows; trackBy: trackByIndex">
                <td>{{ rb.key }}</td>
                <td class="numeric">{{ rb.count | number }}</td>
                <td><span class="dh-pill" [ngClass]="ringBufferStatusClass(rb.health)">{{ rb.health }}</span></td>
              </tr>
            </tbody>
          </table>
          <p class="muted" style="margin-top:8px;">Ring buffer thresholds are configured per buffer type.</p>
        </article>
      </div>

      <div class="dh-bottom-grid">
        <article class="panel dh-panel dh-table-panel">
          <div class="section-head-row">
            <div>
              <h3 class="section-title">Data Health by NAMC / Shop</h3>
              <p class="muted">Expand a row to view detailed data health metrics for each shop.</p>
            </div>
            <div class="table-actions">
              <div class="search-wrap">
                <input class="search-input" type="text" placeholder="Search NAMC or Shop"
                  [(ngModel)]="dataHealthSearchTerm" aria-label="Search NAMC or Shop" />
              </div>
              <button class="btn-ghost" type="button" (click)="expandAllDataHealthNamcs()">Expand All</button>
              <button class="btn-ghost" type="button" (click)="collapseAllDataHealthNamcs()">Collapse All</button>
              <button class="btn-ghost btn-ghost--export" type="button">Export</button>
            </div>
          </div>

          <div class="table-wrap">
            <table class="data-table dh-table">
              <thead>
                <tr>
                  <th>NAMC / Shop</th>
                  <th class="numeric">Health Count</th>
                  <th class="numeric">Health Fault Count</th>
                  <th class="numeric">Health %</th>
                  <th class="numeric">Quality Count</th>
                  <th class="numeric">Quality Fault Count</th>
                  <th class="numeric">Quality %</th>
                  <th class="numeric">Event RB</th>
                  <th class="numeric">Tool RB</th>
                  <th class="numeric">Trend RB</th>
                  <th class="numeric">Cycle RB</th>
                  <th class="numeric">Summary RB</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of filteredDataHealthNamcRows; trackBy: trackByDataHealthNamc">
                  <tr class="namc-row" (click)="toggleDataHealthNamc(row.namc)">
                    <td>
                      <span class="expand-chevron" [class.expand-chevron--open]="isDataHealthNamcExpanded(row.namc)">&#9656;</span>
                      <strong>{{ row.namc }}</strong>
                    </td>
                    <td class="numeric">{{ row.healthCount | number }}</td>
                    <td class="numeric">{{ row.healthFaultCount | number }}</td>
                    <td class="numeric">{{ row.healthPct | number:'1.1-1' }}%</td>
                    <td class="numeric">{{ row.qualityCount | number }}</td>
                    <td class="numeric">{{ row.qualityFaultCount | number }}</td>
                    <td class="numeric">{{ row.qualityPct | number:'1.1-1' }}%</td>
                    <td class="numeric">{{ row.eventRb | number }}</td>
                    <td class="numeric">{{ row.toolRb | number }}</td>
                    <td class="numeric">{{ row.trendRb | number }}</td>
                    <td class="numeric">{{ row.cycleRb | number }}</td>
                    <td class="numeric">{{ row.summaryRb | number }}</td>
                    <td><span class="status-badge" [ngClass]="dataHealthStatusClass(row.status)">{{ row.status }}</span></td>
                  </tr>
                  <tr class="shop-row" *ngFor="let shop of row.shopRows; trackBy: trackByDataHealthShop"
                    [class.hidden-row]="!isDataHealthNamcExpanded(row.namc)">
                    <td class="shop-name-cell"><span class="shop-indent"></span>{{ row.namc }}_{{ shop.shop }}</td>
                    <td class="numeric">{{ shop.healthCount ?? 0 | number }}</td>
                    <td class="numeric">{{ shop.healthFaultCount ?? 0 | number }}</td>
                    <td class="numeric">{{ shop.healthPct ?? 0 | number:'1.1-1' }}%</td>
                    <td class="numeric">{{ shop.qualityCount ?? 0 | number }}</td>
                    <td class="numeric">{{ shop.qualityFaultCount ?? 0 | number }}</td>
                    <td class="numeric">{{ shop.qualityPct ?? 0 | number:'1.1-1' }}%</td>
                    <td class="numeric">{{ shop.eventRb ?? 0 | number }}</td>
                    <td class="numeric">{{ shop.toolRb ?? 0 | number }}</td>
                    <td class="numeric">{{ shop.trendRb ?? 0 | number }}</td>
                    <td class="numeric">{{ shop.cycleRb ?? 0 | number }}</td>
                    <td class="numeric">{{ shop.summaryRb ?? 0 | number }}</td>
                    <td><span class="status-badge" [ngClass]="dataHealthShopStatusClass(shop)">{{ dataHealthShopStatusLabel(shop) }}</span></td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </article>
      </div>

      <article class="panel dh-panel dh-info-panel dh-note-panel">
        <h3 class="section-title">Why 100% is not always Good</h3>
        <p class="muted">A Health % of 100 may mean no faults have been captured, but it can also mean there is little or no data being produced.</p>
        <p class="muted" style="margin-top:10px;">Shops with 100% Health are flagged as Verify and require manual review.</p>
        <div class="dh-reasons">
          <h4>Common reasons include:</h4>
          <ul>
            <li>Zero Health Count</li>
            <li>Zero Fault Count</li>
            <li>Sensors not configured</li>
            <li>No data being produced</li>
            <li>Configuration not verified</li>
          </ul>
        </div>
      </article>
    </ng-container>

    <ng-template #dhLoadingState>
      <article class="panel">
        <h3 class="section-title">Data Health</h3>
        <p class="muted">Loading data health metrics from CSV...</p>
      </article>
    </ng-template>

    <article *ngIf="dataHealthError" class="panel">
      <h3 class="section-title">Data Health</h3>
      <p class="muted">Unable to load CSV data: {{ dataHealthError }}</p>
    </article>
